import { render, staticRenderFns } from "./RegistrationRow.vue?vue&type=template&id=5c94014e"
import script from "./RegistrationRow.vue?vue&type=script&lang=js"
export * from "./RegistrationRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports